module.exports = __webpack_public_path__ + "img/money.d4873073.svg";